import { styled } from '@mui/material/styles';
import { Box, Paper, Typography, Grid, Divider, Button } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '29vh',
  margin: '1rem 0',
  
  [theme.breakpoints.down('bp1500')]: {
    height: '33vh',
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: '#EBFFFB',
  borderRadius: '10px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'initial',
  },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  width: '15%',
  height: '100%',
  display: 'flex',

  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  width: '63%',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),

  [theme.breakpoints.down('md')]: {
    width: '73%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  height: '35%',
  marginTop: theme.spacing(1),
  color: '#242424',
  fontWeight: 700,
  fontSize: '1.2rem',

  [theme.breakpoints.down('xl')]: {
    fontSize: '1.1rem',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem',
  },
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  height: '40%',
  fontSize: '0.8rem',

  [theme.breakpoints.down('xl')]: {
    fontSize: '0.8rem',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.down('md')]: {
    height: '35%'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem',
  },
}));

export const InfoItem = styled(Typography)(({ theme }) => ({
  width: '35%',
  fontSize: '0.8rem',

  [theme.breakpoints.down('mdlg')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.down('sm')]: {
    width: '44%',
    fontSize: '0.6rem',
  },
}));

export const ActionBox = styled(Box)(({ theme }) => ({
  width: '18%',
  height: '80%',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'initial',
  gap: theme.spacing(4),

  [theme.breakpoints.down('md')]: {
    width: '25%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    height: '10%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export const PriceText = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  fontWeight: 400,

  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    fontWeight: 900,
  },
}));

export const RequestButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  width: '11vw',
  fontSize: '0.875rem',
  fontWeight: 500,
  color: 'white',
  backgroundColor: '#242424',

  [theme.breakpoints.down('xl')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.down('lg')]: {
    width: '13vw',
    fontSize: '0.6rem',
  },
  [theme.breakpoints.down('mdlg')]: {
    width: '17vw',
    fontSize: '0.6rem',
  },
  [theme.breakpoints.down('sm')]: {
    width: '30vw',
    height: '3vh',
    fontSize: '0.53rem',
    fontWeight: 900,
  },
}));

export const BuyButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  width: '11vw',
  fontSize: '0.875rem',
  fontWeight: 700,
  color: 'black',
  backgroundColor: '#ffdd24',
  paddingTop: theme.spacing(1),

  [theme.breakpoints.down('xl')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.down('lg')]: {
    width: '13vw',
    fontSize: '0.6rem',
  },
  [theme.breakpoints.down('mdlg')]: {
    width: '17vw',
    fontSize: '0.6rem',
  },
  [theme.breakpoints.down('sm')]: {
    width: '20vw',
    height: '3vh',
    fontSize: '0.53rem',
    fontWeight: 900,
  },
}));